import { useDispatch } from 'react-redux'
import { KonektoNavbar } from '../../components'
import Footer from '../../components/footer/Footer'
import './Registration.scss'
import { useState } from 'react'
import { validateEmail } from '../../helpers'
import { Spinner } from 'react-bootstrap'
import { authService } from '../../services/authService'
import { loginSuccess } from '../../store/Actions/Authentication'
import { useNavigate } from 'react-router-dom'

export default function Registration() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [passwordConfirm, setPasswordConfirm] = useState('')

  const [registrationFormErrors, setRegistrationFormErrors] = useState(null)
  const [registrationResponseErrors, setRegistrationResponseErrors] =
    useState(null)
  const [registrationLoader, setRegistrationLoader] = useState(false)

  const onRegister = async e => {
    setRegistrationFormErrors(null)
    e.preventDefault()

    let newErrors = {}

    if (!validateEmail(email)) {
      newErrors = { ...newErrors, email: 'Email nije validan' }
    }

    if (firstName?.trim() === '') {
      newErrors = { ...newErrors, firstName: 'Ime ne može biti prazno' }
    }

    if (lastName?.trim() === '') {
      newErrors = { ...newErrors, lastName: 'Prezime ne može biti prazno' }
    }

    if (password?.trim() === '') {
      newErrors = { ...newErrors, password: 'Lozinka ne može biti prazna' }
    }

    if (password !== passwordConfirm) {
      newErrors = { ...newErrors, passwordConfirm: 'Lozinke nisu identične' }
    }

    if (Object.keys(newErrors).length > 0) {
      setRegistrationFormErrors(newErrors)
      return
    }

    setRegistrationLoader(true)

    const registerResponse = await authService.register({
      firstName,
      lastName,
      email,
      password,
      passwordConfirm,
    })
    if (registerResponse.isOk && registerResponse.data) {
      dispatch(loginSuccess(registerResponse.data.token))
      navigate('/')
    } else {
      setRegistrationResponseErrors(registerResponse.message)
    }

    setRegistrationLoader(false)
  }

  return (
    <div id="registration">
      <KonektoNavbar />
      <div className="container my-5">
        <h1 className="fw-bold text-center px-2">
          Pridružite se vodećem B2B tržištu u BiH danas
        </h1>

        <h4 className="mt-4 text-center fw-normal px-2">
          Kreirajte besplatnu stranicu za svoju firmu i povežite se s kupcima.
        </h4>

        <div className="row mt-5">
          {/* Left Column - Form */}
          <div className="col-md-6 left-column">
            <form>
              <div className="row mb-3">
                <div className="col">
                  <input
                    type="text"
                    className="form-control shadow"
                    id="firstName"
                    placeholder="Ime *"
                    onChange={e => {
                      setFirstName(e.target.value)
                      if (registrationFormErrors?.firstName) {
                        setRegistrationFormErrors({
                          ...registrationFormErrors,
                          firstName: null,
                        })
                      }
                    }}
                  />
                  {registrationFormErrors?.firstName ? (
                    <span className="field-error">
                      {registrationFormErrors?.firstName}
                    </span>
                  ) : null}
                </div>
                <div className="col">
                  <input
                    type="text"
                    className="form-control shadow"
                    id="lastName"
                    placeholder="Prezime *"
                    onChange={e => {
                      setLastName(e.target.value)
                      if (registrationFormErrors?.lastName) {
                        setRegistrationFormErrors({
                          ...registrationFormErrors,
                          lastName: null,
                        })
                      }
                    }}
                  />
                  {registrationFormErrors?.lastName ? (
                    <span className="field-error">
                      {registrationFormErrors?.lastName}
                    </span>
                  ) : null}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col">
                  <input
                    type="email"
                    className="form-control shadow"
                    id="email"
                    placeholder="Email *"
                    onChange={e => {
                      setEmail(e.target.value)
                      if (registrationFormErrors?.email) {
                        setRegistrationFormErrors({
                          ...registrationFormErrors,
                          email: null,
                        })
                      }
                    }}
                  />
                  {registrationFormErrors?.email ? (
                    <span className="field-error">
                      {registrationFormErrors?.email}
                    </span>
                  ) : null}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col">
                  <input
                    type="password"
                    className="form-control shadow"
                    id="password"
                    placeholder="Lozinku *"
                    onChange={e => {
                      setPassword(e.target.value)
                      if (registrationFormErrors?.password) {
                        setRegistrationFormErrors({
                          ...registrationFormErrors,
                          password: null,
                        })
                      }
                    }}
                  />
                  {registrationFormErrors?.password ? (
                    <span className="field-error">
                      {registrationFormErrors?.password}
                    </span>
                  ) : null}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col">
                  <input
                    type="password"
                    className="form-control shadow"
                    id="password"
                    placeholder="Ponovite lozinku *"
                    onChange={e => {
                      setPasswordConfirm(e.target.value)
                      if (registrationFormErrors?.passwordConfirm) {
                        setRegistrationFormErrors({
                          ...registrationFormErrors,
                          passwordConfirm: null,
                        })
                      }
                    }}
                  />
                  {registrationFormErrors?.passwordConfirm ? (
                    <span className="field-error">
                      {registrationFormErrors?.passwordConfirm}
                    </span>
                  ) : null}
                </div>
              </div>

              {registrationResponseErrors ? (
                <p className="field-error text-center mb-0 mt-2">
                  {registrationResponseErrors}
                </p>
              ) : null}
            </form>
          </div>

          {/* Right Column */}
          <div className="col-md-6 right-column">
            <ul>
              <li>Povećajte online prisutnost i vidljivost vaše firme</li>
              <li>Promovišite svoje proizvode i usluge</li>
              <li>Privucite nove kupce i povećajte vašu prodaju</li>
            </ul>

            <button
              onClick={onRegister}
              disabled={registrationLoader}
              className="btn btn-primary mt-3 rounded-pill">
              {registrationLoader ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                'Započni Registraciju'
              )}
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}
